// import { useState } from "react";
// import { useNavigate } from "react-router-dom";   // <-- add this

// import "./RoomAvaiblity.css"

// import { FaCheckCircle, FaExclamationTriangle , FaBed, FaCouch , FaUsers } from "react-icons/fa";

// const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};
// const checkInDate = JSON.parse(localStorage.getItem("BookingDate")) ? new Date(JSON.parse(localStorage.getItem("BookingDate")).checkIn) : {};
// const checkOutDate =JSON.parse(localStorage.getItem("BookingDate")) ?  new Date(JSON.parse(localStorage.getItem("BookingDate")).checkOut): {};
// const nights = Math.max(
//   1,
//   Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24))
// );
// console.log(nights)

// const Availability = ({ property }) => {

//     const navigate = useNavigate()





//   const [selectedRoom, setSelectedRoom] = useState(null); // store selected room info
//   const [selectedCount, setSelectedCount] = useState(0); // store number of rooms

//   const handleSelect = (value, room) => {
//     setSelectedCount(Number(value));
//     setSelectedRoom(room);
//   };






//   const setReverse = () => {
//   // check discount active hai ya nahi
//   const isDiscountActive = selectedRoom?.discount?.isDiscountActive;
//   const isDiscountActive1 = selectedRoom?.discount?.isDiscountActive ? true : false ;

//   // price calculate (discount ke sath ya bina discount)
//   const roomPrice = isDiscountActive
//     ? selectedRoom.discount.priceAfterDiscount
//     : selectedRoom.nightlyPrice;

//   const totalPrice = Number(roomPrice * selectedCount * nights);

//   const data = {
//     stayDurationInDays: nights,
//     bookingDate: {
//       startDate: bookingData.checkIn,
//       endDate: bookingData.checkOut,
//     },
//     totalPrice, // updated price with discount logic
//     noOfRooms: selectedCount,
//     Room: selectedRoom,
//     property,
//     taxs : selectedRoom.tax * selectedCount ,
//     // adminCommission : selectedRoom.adminCommission ,
//     discountApplied: isDiscountActive1,
//     discount: isDiscountActive1
//       ? {
//           percentage: selectedRoom.discount.discountPercentage,
//           discountedNightPrice: selectedRoom.discount.priceAfterDiscount,
//         }
//       : null,
//   };

//   localStorage.setItem("Selected_Room", JSON.stringify(data));

//   navigate(`/book`);

//   console.log(data);
// };







//     console.log(property)
//   return (
//     <div className="availability">
    
//       <div className="search-section">
//   {/* <h3 className="search-title">Search Availability</h3> */}

//   <div className="search-bar">
//     <div className="search-field">
//       <label>Location</label>
//       <input type="text" className="date-input" />
//     </div>
//     <div className="search-field">
//       <label>Check-in</label>
//       <input type="date" className="date-input" />
//     </div>

//     <div className="search-field">
//       <label>Check-out</label>
//       <input type="date" className="date-input" />
//     </div>

//     <div className="search-field">
//       <label>Guests</label>
//       <select className="guest-select">
//         <option>2 adults · 0 children · 1 room</option>
//       </select>
//     </div>

//     <button className="search-btn">Search</button>
//   </div>
// </div>


   



// <div className="availability-table1" style={{display:"flex"}}>

//       <table className="availability-table">
//   <thead>
//     <tr>
//       <th>Room Type</th>
//       <th>Number of guests</th>
//       <th>Price for {nights} nights</th>
//       <th>Your choices</th>
//       <th>Select Rooms</th>
//     </tr>
//   </thead>
//   <tbody>
   



//  {property.rooms.map((room) => {
//   // nights calculate already kiya hua hai
//   const hasDiscount = room?.discount?.isDiscountActive;
//   const nightlyPrice = hasDiscount
//     ? room.discount.priceAfterDiscount
//     : room.nightlyPrice;

//   const totalPrice = nightlyPrice * nights;

//   return (
//     <tr key={room.roomId}>
//       {/* Room Type */}
//       <td>
//         <div className="room-type">
//           <a href="#" className="room-link">
//             {room.roomDetails.roomName}
//           </a>
//           <div className="room-details">
//             {renderBeds(room.bedroomBeds, room.livingRoomBeds)} <FaBed />
//           </div>
//         </div>
//       </td>

//       {/* Guests */}
//       <td>
//         <div className="guests-icons">
//           {Array.from({ length: room.guests }).map((_, idx) => (
//             <FaUsers key={idx} />
//           ))}
//         </div>
//       </td>

//       {/* Price */}
//       <td>
//         <span className="price">
//           PKR {totalPrice.toLocaleString()}
//         </span>

//         {/* Show discount if active */}
//         {hasDiscount && (
//           <div className="discount-note" style={{ color: "red" }}>
//             <s>PKR {(room.nightlyPrice * nights).toLocaleString()}</s>{" "}
//             ({room.discount.discountPercentage}% off)
//           </div>
//         )}

//         <div className="price-note">+ taxes and charges</div>
//       </td>

//       {/* Your choices */}
//       <td>
//         <ul className="choices-list">
//           {room.breakfast?.types && room.breakfast.types[0] && (
//             <li style={{ color: "green", marginBottom: "12px" }}>
//               <FaCheckCircle style={{ marginRight: "6px" }} />
//               Continental breakfast included
//             </li>
//           )}

//           <li style={{ marginBottom: "12px" }}>
//             <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//             <b>No prepayment needed</b> – pay at the property
//           </li>

//           <li>
//             <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} />
//             We have {room.roomDetails.noOfRooms} left
//           </li>
//         </ul>
//       </td>

//       {/* Select Rooms */}
//       <td style={{ width: "90px" }}>
//         <select
//           className="room-select"
//           style={{ width: "90px" }}
//           onChange={(e) => handleSelect(e.target.value, room)}
//         >
//           {Array.from({ length: room.roomDetails.noOfRooms + 1 }).map(
//             (_, i) => {
//               const optionPrice = i * nightlyPrice * nights;
//               return (
//                 <option key={i} value={i}>
//                   {i === 0
//                     ? "0"
//                     : `${i} × PKR ${totalPrice.toLocaleString()} = PKR ${optionPrice.toLocaleString()}`}
//                 </option>
//               );
//             }
//           )}
//         </select>
//       </td>
//     </tr>
//   );
// })}

  
    
//   </tbody>
  
// </table>


// {selectedRoom && selectedCount > 0 && (
//   <div className="summary-box">
//     {/** Agar discount active hai to use karo warna normal price */}
//     {selectedRoom.discount?.isDiscountActive ? (
//       <h4>
//         {selectedCount} room{selectedCount > 1 ? "s" : ""} for{" "}
//         <span className="price" style={{ color: "green" }}>
//           PKR {(
//             (selectedRoom.discount.priceAfterDiscount * selectedCount) *
//             nights
//           ).toLocaleString()}
//         </span>{" "}
//         <span
//           style={{
//             textDecoration: "line-through",
//             color: "red",
//             marginLeft: "8px",
//             fontSize: "14px",
//           }}
//         >
//           PKR {(
//             (selectedRoom.nightlyPrice * selectedCount) *
//             nights
//           ).toLocaleString()}
//         </span>{" "}
//         <span style={{ color: "green", marginLeft: "8px" }}>
//           ({selectedRoom.discount.discountPercentage}% off)
//         </span>
//       </h4>
//     ) : (
//       <h4>
//         {selectedCount} room{selectedCount > 1 ? "s" : ""} for{" "}
//         <span className="price">
//           PKR {(
//             (selectedRoom.nightlyPrice * selectedCount) *
//             nights
//           ).toLocaleString()}
//         </span>
//       </h4>
//     )}

//     <p>+ {(selectedRoom.tax * nights )* selectedCount} taxes and fees</p>

//     <button className="reserve-btn" onClick={() => setReverse()}>
//       I'll reserve
//     </button>
//     <br />
//     <p className="note">Let's go to the next step</p>
//     <p className="note">You won't be charged yet</p>

//     <h5>Your package:</h5>
//     <ul className="choices-list">
//       {selectedRoom.breakfast?.types && selectedRoom.breakfast.types[0] && (
//         <li>
//           <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//           Continental breakfast included
//         </li>
//       )}
//       <br />
//       <li>
//         <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//         No prepayment needed – pay at the property
//       </li>
//       <br />
//       <li>
//         <FaExclamationTriangle
//           style={{ marginRight: "6px", color: "red" }}
//         />
//         We have {selectedRoom.roomDetails.noOfRooms} left
//       </li>
//     </ul>
//   </div>
// )}





//       </div>

//     </div>
//   );
// };

// // Helper: Convert bed info into readable string
// const renderBeds = (bedroomBeds = {}, livingRoomBeds = {}) => {
//   let beds = [];

//   // Bedroom beds
//   if (bedroomBeds.single > 0) beds.push(`${bedroomBeds.single} single`);
//   if (bedroomBeds.double > 0) beds.push(`${bedroomBeds.double} double`);
//   if (bedroomBeds.king > 0) beds.push(`${bedroomBeds.king} king`);
//   if (bedroomBeds.queen > 0) beds.push(`${bedroomBeds.queen} queen`);
//   if (bedroomBeds.sofaCome > 0) beds.push(`${bedroomBeds.sofaCome} sofa bed`);

//   // Living room beds
//   if (livingRoomBeds.sofa > 0) beds.push(`${livingRoomBeds.sofa} sofa`);
//   if (livingRoomBeds.sleeperSofas > 0) beds.push(`${livingRoomBeds.sleeperSofas} sleeper sofa`);
//   if (livingRoomBeds.futons > 0) beds.push(`${livingRoomBeds.futons} futon`);
//   if (livingRoomBeds.chair > 0) beds.push(`${livingRoomBeds.chair} chair`);

//   return beds.join(", ");
// };


// export default Availability




























































// import { useState ,useEffect } from "react";
// import { useNavigate } from "react-router-dom";   // <-- add this

// import "./RoomAvaiblity.css"

// import { FaCheckCircle, FaExclamationTriangle , FaBed, FaCouch , FaUsers } from "react-icons/fa";

// const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};
// const checkInDate = bookingData.checkIn ? new Date(bookingData.checkIn) : new Date();
// const checkOutDate = bookingData.checkOut ? new Date(bookingData.checkOut) : new Date();
// const nights = Math.max(
//   1,
//   Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24))
// );
// console.log(nights)



// // 🔹 NEW FUNCTION: Get room price (Discount > Calendar > Nightly)
// const getRoomPriceForDate = (room, date) => {
//   const checkDate = new Date(date);

//   // 1️⃣ Discount check
//   if (room.discount?.isDiscountActive && room.discount?.priceAfterDiscount != null) {
//     return room.discount.priceAfterDiscount;
//   }

//   // 2️⃣ Calendar check
//   if (room.calendar?.length > 0) {
//     for (const entry of room.calendar) {
//       const start = new Date(entry.startDate);
//       const end = new Date(entry.endDate);
//       if (checkDate >= start && checkDate <= end) {
//         if (entry.status === "close") return null; // room closed
//         if (entry.status === "open" && entry.price != null) return entry.price;
//       }
//     }
//   }

//   // 3️⃣ fallback nightlyPrice
//   return room.nightlyPrice ?? null;
// };

// const Availability = ({ property }) => {
//     const navigate = useNavigate()

//     const [selectedRoom, setSelectedRoom] = useState(null); // store selected room info
//     const [selectedCount, setSelectedCount] = useState(0); // store number of rooms

//       const [formData, setFormData] = useState({
//     destination: "",
//     checkIn: "",
//     checkOut: "",
//     adults: 0 ,
//     children: 0,
//     rooms: 0,
//     childrenAgesNeeded: [],
//   });


//   const [showGuestPopup, setShowGuestPopup] = useState(false);


//   useEffect(() => {

    
//      const today = new Date();
//   const tomorrow = new Date();
//   tomorrow.setDate(today.getDate() + 1);

//   // dates ko yyyy-mm-dd format mein convert karna (jo input[type="date"] accept karta hai)
//   const formatDate = (date) => {
//     return date.toISOString().split("T")[0];
//   };

//     setFormData({
//       destination: property?.city,
//     checkIn: formatDate(today),
//     checkOut: formatDate(tomorrow),
//     adults: 0 ,
//     children: 0,
//     rooms: 0,
//     childrenAgesNeeded: [],
//     })
//     const stored = JSON.parse(localStorage.getItem("BookingDate"));
//     if (stored) {
//       setFormData(stored);
//     }

//   }, []);


//     const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

// const handleGuestChange = (type, action) => {
//     setFormData((prev) => {
//       let updated = { ...prev };

//       if (type === "adults") {
//         updated.adults = Math.max(1, action === "inc" ? prev.adults + 1 : prev.adults - 1);
//       }
//       if (type === "children") {
//         let newChildren = Math.max(0, action === "inc" ? prev.children + 1 : prev.children - 1);
//         updated.children = newChildren;
//         updated.childrenAgesNeeded = Array(newChildren).fill(0); // default 0 years
//       }
//       if (type === "rooms") {
//         updated.rooms = Math.max(1, action === "inc" ? prev.rooms + 1 : prev.rooms - 1);
//       }

//       return updated;
//     });
//   };

//   const handleChildAgeChange = (index, value) => {
//     setFormData((prev) => {
//       let newAges = [...prev.childrenAgesNeeded];
//       newAges[index] = value;
//       return { ...prev, childrenAgesNeeded: newAges };
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (formData.rooms === 0 || formData.adults === 0) {
//     toast.success("Please select at least 1 room and 1 adult ❌");
//     return;
//   }

//   if (!formData.checkIn || !formData.checkOut) {
//     toast.success("Please select both check-in and check-out dates ❌");
//     return;
//   }


//     localStorage.setItem("BookingDate", JSON.stringify(formData));
//     toast.success("Booking data saved to localStorage ✅");
//   };




//     const handleSelect = (value, room) => {
//         setSelectedCount(Number(value));
//         setSelectedRoom(room);
//     };

//     const setReverse = () => {


//     let BookingData = JSON.parse(localStorage.getItem("BookingDate"))
//       if(BookingData){
//          const roomPrice = getRoomPriceForDate(selectedRoom, bookingData.checkIn);
//         const totalPrice = Number(roomPrice * selectedCount * nights);

//         const isDiscountActive = selectedRoom?.discount?.isDiscountActive ? true : false ;



//     let totalTax = 0;
//     for (let i = 0; i < nights; i++) {
//         const date = new Date(bookingData.checkIn);
//         date.setDate(date.getDate() + i);
//         const nightlyPrice = getRoomPriceForDate(selectedRoom, date);
//         totalTax += nightlyPrice * (selectedRoom.tax / selectedRoom.nightlyPrice || 0);
//     }
//     totalTax = totalTax * selectedCount;

//         const data = {
//             stayDurationInDays: nights,
//             bookingDate: {
//               startDate: bookingData.checkIn,
//               endDate: bookingData.checkOut,
//             },
//             totalPrice, // updated price with discount logic
//             noOfRooms: selectedCount,
//             Room: selectedRoom,
//             property,
//             // taxs : selectedRoom.tax * selectedCount ,
//             taxs : totalTax ,
//             discountApplied: isDiscountActive,
//             discount: isDiscountActive
//               ? {
//                   percentage: selectedRoom.discount.discountPercentage,
//                   discountedNightPrice: selectedRoom.discount.priceAfterDiscount,
//                 }
//               : null,
//         };

//         localStorage.setItem("Selected_Room", JSON.stringify(data));
//         navigate(`/book`);
//         console.log(data);
//       }
//       else{
//         toast.success("Please Enter Your Booking Dates To Conform The Reservation")
//       }

       
//     };

//     console.log(property)
//     return (
//         <div className="availability">
//             {/* Search Section */}
//             {/* <div className="search-section">
//                 <div className="search-bar">
//                     <div className="search-field">
//                       <label>Location</label>
//                       <input type="text" className="date-input" />
//                     </div>
//                     <div className="search-field">
//                       <label>Check-in</label>
//                       <input type="date" className="date-input" />
//                     </div>
//                     <div className="search-field">
//                       <label>Check-out</label>
//                       <input type="date" className="date-input" />
//                     </div>
//                     <div className="search-field">
//                       <label>Guests</label>
//                       <select className="guest-select">
//                         <option>2 adults · 0 children · 1 room</option>
//                       </select>
//                     </div>
//                     <button className="search-btn">Search</button>
//                 </div>
//             </div> */}


// {/* <div className="search-section">
//       <form className="search-bar" onSubmit={handleSubmit}>
//         <div className="search-field">
//           <label>Location</label>
//           <input
//             type="text"
//             className="date-input"
//             name="destination"
//             value={formData.destination}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="search-field">
//           <label>Check-in</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkIn"
//             value={formData.checkIn}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="search-field">
//           <label>Check-out</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkOut"
//             value={formData.checkOut}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="search-field">
//           <label>Guests</label>
//           <select
//             className="guest-select"
//             name="guests"
//             onChange={(e) => {
//               const [adults, children, rooms] = e.target.value.split("|");
//               setFormData((prev) => ({
//                 ...prev,
//                 adults: parseInt(adults),
//                 children: parseInt(children),
//                 rooms: parseInt(rooms),
//               }));
//             }}
//             value={`${formData.adults}|${formData.children}|${formData.rooms}`}
//           >
//             <option value="2|0|1">2 adults · 0 children · 1 room</option>
//             <option value="1|0|1">1 adult · 0 children · 1 room</option>
//             <option value="2|1|1">2 adults · 1 child · 1 room</option>
//             <option value="2|0|2">2 adults · 0 children · 2 rooms</option>
//           </select>
//         </div>

//         <button type="submit" className="search-btn">
//           Search
//         </button>
//       </form>
//     </div> */}




// <div className="search-section" style={{justifyContent:"flex-start"}}>
//       <form className="search-bar" onSubmit={handleSubmit}>
//         {/* Destination */}
//         <div className="search-field">
//           <label>Location</label>
//           <input
//             type="text"
//             className="date-input"
//             name="destination"
//             value={formData.destination}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Check-in */}
//         <div className="search-field">
//           <label>Check-in</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkIn"
//             value={formData.checkIn}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Check-out */}
//         <div className="search-field">
//           <label>Check-out</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkOut"
//             value={formData.checkOut}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Guests Popup */}
//         <div className="search-field" style={{ position: "relative" , minWidth:"220px" }}>
//           <label>Guests</label>
//           <div
//             className="guest-box"
//             onClick={() => setShowGuestPopup(!showGuestPopup)}
//           >
//             {formData.adults} adults · {formData.children} children · {formData.rooms} room
//           </div>

//           {showGuestPopup && (
//             <div className="guest-popup">
//               <div className="guest-row">
//                 <span>Adults</span>
//                 <div>
//                   <button type="button" onClick={() => handleGuestChange("adults", "dec")}>-</button>
//                   <span>{formData.adults}</span>
//                   <button type="button" onClick={() => handleGuestChange("adults", "inc")}>+</button>
//                 </div>
//               </div>
//               <div className="guest-row">
//                 <span>Children</span>
//                 <div>
//                   <button type="button" onClick={() => handleGuestChange("children", "dec")}>-</button>
//                   <span>{formData.children}</span>
//                   <button type="button" onClick={() => handleGuestChange("children", "inc")}>+</button>
//                 </div>
//               </div>
//               <div className="guest-row">
//                 <span>Rooms</span>
//                 <div>
//                   <button type="button" onClick={() => handleGuestChange("rooms", "dec")}>-</button>
//                   <span>{formData.rooms}</span>
//                   <button type="button" onClick={() => handleGuestChange("rooms", "inc")}>+</button>
//                 </div>
//               </div>

//               {/* Child Ages */}
//               {formData.children > 0 && (
//                 <div className="child-ages">
//                   <label>Children Ages</label>
//                   {formData.childrenAgesNeeded.map((age, idx) => (
//                     <select
//                       key={idx}
//                       value={age}
//                       onChange={(e) => handleChildAgeChange(idx, e.target.value)}
//                     >
//                       {Array.from({ length: 18 }, (_, i) => (
//                         <option key={i} value={i}>{i} years old</option>
//                       ))}
//                     </select>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* Submit */}
//         <button type="submit" className="search-btn">
//           Search
//         </button>
//       </form>
//     </div>

//             {/* Availability Table */}
//             <div className="availability-table1" style={{display:"flex"}}>
//                 <table className="availability-table">
//                     <thead>
//                         <tr>
//                             <th>Room Type</th>
//                             <th>Number of guests</th>
//                             <th>Price for {nights} nights</th>
//                             <th>Your choices</th>
//                             <th>Select Rooms</th>
//                         </tr>
//                     </thead>
//                     <tbody>

//                     {property.rooms.map((room) => {
//                         // 🔹 UPDATED: Use getRoomPriceForDate
//                         const nightlyPrice = getRoomPriceForDate(room, bookingData.checkIn);
//                         const totalPrice = nightlyPrice * nights;
//                         const hasDiscount = room.discount?.isDiscountActive;

//                         return (
//                             <tr key={room.roomId}>
//                                 {/* Room Type */}
//                                 <td>
//                                     <div className="room-type">
//                                         <a href="#" className="room-link">{room.roomDetails.roomName}</a>
//                                         <div className="room-details">{renderBeds(room.bedroomBeds, room.livingRoomBeds)} <FaBed /></div>
//                                     </div>
//                                 </td>

//                                 {/* Guests */}
//                                 <td>
//                                     <div className="guests-icons">
//                                       {Array.from({ length: room.guests }).map((_, idx) => (<FaUsers key={idx} />))}
//                                     </div>
//                                 </td>

//                                 {/* Price */}
//                                 <td>
//                                     <span className="price">PKR {totalPrice.toLocaleString()}</span>
//                                     {hasDiscount && (
//                                         <div className="discount-note" style={{ color: "red" }}>
//                                             <s>PKR {(room.nightlyPrice * nights).toLocaleString()}</s>{" "}
//                                             ({room.discount.discountPercentage}% off)
//                                         </div>
//                                     )}
//                                     <div className="price-note">+ taxes and charges</div>
//                                 </td>

//                                 {/* Your choices */}
//                                 <td>
//                                     <ul className="choices-list">
//                                       {room.breakfast?.types && room.breakfast.types[0] && (
//                                         <li style={{ color: "green", marginBottom: "12px" }}>
//                                           <FaCheckCircle style={{ marginRight: "6px" }} />
//                                           Continental breakfast included
//                                         </li>
//                                       )}
//                                       <li style={{ marginBottom: "12px" }}>
//                                         <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//                                         <b>No prepayment needed</b> – pay at the property
//                                       </li>
//                                       <li>
//                                         <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} />
//                                         We have {room.roomDetails.noOfRooms} left
//                                       </li>
//                                     </ul>
//                                 </td>

//                                 {/* Select Rooms */}
//                                 <td style={{ width: "90px" }}>
//                                     <select
//                                         className="room-select"
//                                         style={{ width: "90px" }}
//                                         onChange={(e) => handleSelect(e.target.value, room)}
//                                     >
//                                         {Array.from({ length: room.roomDetails.noOfRooms + 1 }).map((_, i) => {
//                                             const optionPrice = i * nightlyPrice * nights;
//                                             return (
//                                               <option key={i} value={i}>
//                                                 {i === 0
//                                                   ? "0"
//                                                   : `${i} × PKR ${totalPrice.toLocaleString()} = PKR ${optionPrice.toLocaleString()}`}
//                                               </option>
//                                             );
//                                         })}
//                                     </select>
//                                 </td>
//                             </tr>
//                         );
//                     })}
//                     </tbody>
//                 </table>

//                 {/* Summary Box */}
//                 {/* {selectedRoom && selectedCount > 0 && (
//                   <div className="summary-box">
//                       {selectedRoom.discount?.isDiscountActive ? (
//                         <h4>
//                           {selectedCount} room{selectedCount > 1 ? "s" : ""} for{" "}
//                           <span className="price" style={{ color: "green" }}>
//                             PKR {(
//                               (selectedRoom.discount.priceAfterDiscount * selectedCount) *
//                               nights
//                             ).toLocaleString()}
//                           </span>{" "}
//                           <span style={{ textDecoration: "line-through", color: "red", marginLeft: "8px", fontSize: "14px" }}>
//                             PKR {((selectedRoom.nightlyPrice * selectedCount) * nights).toLocaleString()}
//                           </span>{" "}
//                           <span style={{ color: "green", marginLeft: "8px" }}>
//                             ({selectedRoom.discount.discountPercentage}% off)
//                           </span>
//                         </h4>
//                       ) : (
//                         <h4>
//                           {selectedCount} room{selectedCount > 1 ? "s" : ""} for{" "}
//                           <span className="price">
//                             PKR {((selectedRoom.nightlyPrice * selectedCount) * nights).toLocaleString()}
//                           </span>
//                         </h4>
//                       )}

//                       <p>+ {(selectedRoom.tax * nights )* selectedCount} taxes and fees</p>

//                       <button className="reserve-btn" onClick={() => setReverse()}>
//                         I'll reserve
//                       </button>
//                       <br />
//                       <p className="note">Let's go to the next step</p>
//                       <p className="note">You won't be charged yet</p>

//                       <h5>Your package:</h5>
//                       <ul className="choices-list">
//                         {selectedRoom.breakfast?.types && selectedRoom.breakfast.types[0] && (
//                           <li>
//                             <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//                             Continental breakfast included
//                           </li>
//                         )}
//                         <br />
//                         <li>
//                           <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//                           No prepayment needed – pay at the property
//                         </li>
//                         <br />
//                         <li>
//                           <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} />
//                           We have {selectedRoom.roomDetails.noOfRooms} left
//                         </li>
//                       </ul>
//                   </div>
//                 )} */}
//                 {selectedRoom && selectedCount > 0 && (
//   <div className="summary-box">
//     {(() => {
//       // 🔹 Total price calculation for all nights
//       let totalPrice = 0;
//       for (let i = 0; i < nights; i++) {
//         const date = new Date(checkInDate);
//         date.setDate(date.getDate() + i);
//         const priceForDay = getRoomPriceForDate(selectedRoom, date);
//         totalPrice += priceForDay;
//       }
//       totalPrice *= selectedCount;

//       const nightlyPriceForCheckIn = getRoomPriceForDate(selectedRoom, checkInDate);
//       const hasDiscount = selectedRoom.discount?.isDiscountActive && nightlyPriceForCheckIn === selectedRoom.discount.priceAfterDiscount;

//       return (
//         <>
//           <h4>
//             {selectedCount} room{selectedCount > 1 ? "s" : ""} for{" "}
//             <span className="price" style={{ color: "green" }}>
//               PKR {totalPrice.toLocaleString()}
//             </span>
//             {hasDiscount && (
//               <span style={{ textDecoration: "line-through", color: "red", marginLeft: "8px", fontSize: "14px" }}>
//                 PKR {((selectedRoom.nightlyPrice * selectedCount) * nights).toLocaleString()}
//               </span>
//             )}
//             {hasDiscount && (
//               <span style={{ color: "green", marginLeft: "8px" }}>
//                 ({selectedRoom.discount.discountPercentage}% off)
//               </span>
//             )}
//           </h4>
//           {/* <p>+ {(selectedRoom.tax * nights )* selectedCount} taxes and fees</p> */}
// <p>
//   + PKR {(() => {
//     let totalTax = 0;
//     for (let i = 0; i < nights; i++) {
//       const date = new Date(checkInDate);
//       date.setDate(date.getDate() + i);
//       const nightlyPrice = getRoomPriceForDate(selectedRoom, date);
//       totalTax += (nightlyPrice * (selectedRoom.tax / selectedRoom.nightlyPrice || 0));
//     }
//     return (totalTax * selectedCount).toLocaleString();
//   })()} taxes and fees
// </p>

//           <button className="reserve-btn" onClick={() => setReverse()}>
//             I'll reserve
//           </button>
//           <br />
//           <p className="note">Let's go to the next step</p>
//           <p className="note">You won't be charged yet</p>

//           <h5>Your package:</h5>
//           <ul className="choices-list">
//             {selectedRoom.breakfast?.types && selectedRoom.breakfast.types[0] && (
//               <li>
//                 <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//                 Continental breakfast included
//               </li>
//             )}
//             <br />
//             <li>
//               <FaCheckCircle style={{ marginRight: "6px", color: "green" }} />
//               No prepayment needed – pay at the property
//             </li>
//             <br />
//             <li>
//               <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} />
//               We have {selectedRoom.roomDetails.noOfRooms} left
//             </li>
//           </ul>
//         </>
//       );
//     })()}
//   </div>
// )}

//             </div>
//         </div>
//     );
// };

// // Helper: Convert bed info into readable string
// const renderBeds = (bedroomBeds = {}, livingRoomBeds = {}) => {
//   let beds = [];
//   if (bedroomBeds.single > 0) beds.push(`${bedroomBeds.single} single`);
//   if (bedroomBeds.double > 0) beds.push(`${bedroomBeds.double} double`);
//   if (bedroomBeds.king > 0) beds.push(`${bedroomBeds.king} king`);
//   if (bedroomBeds.queen > 0) beds.push(`${bedroomBeds.queen} queen`);
//   if (bedroomBeds.sofaCome > 0) beds.push(`${bedroomBeds.sofaCome} sofa bed`);
//   if (livingRoomBeds.sofa > 0) beds.push(`${livingRoomBeds.sofa} sofa`);
//   if (livingRoomBeds.sleeperSofas > 0) beds.push(`${livingRoomBeds.sleeperSofas} sleeper sofa`);
//   if (livingRoomBeds.futons > 0) beds.push(`${livingRoomBeds.futons} futon`);
//   if (livingRoomBeds.chair > 0) beds.push(`${livingRoomBeds.chair} chair`);
//   return beds.join(", ");
// };

// export default Availability;


















// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaCheckCircle, FaExclamationTriangle, FaBed, FaUsers } from "react-icons/fa";
// import "./RoomAvaiblity.css";

// const Availability = ({ property }) => {
//   const navigate = useNavigate();

//   // const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};
//   // const checkInDate = bookingData.checkIn ? new Date(bookingData.checkIn) : new Date();
//   // const checkOutDate = bookingData.checkOut ? new Date(bookingData.checkOut) : new Date();

//   const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};

// const checkInDate = (bookingData && bookingData.BookingDate && bookingData.BookingDate.checkIn)
//   ? new Date(bookingData.BookingDate.checkIn)
//   : (bookingData.checkIn ? new Date(bookingData.checkIn) : new Date());

// const checkOutDate = (bookingData && bookingData.BookingDate && bookingData.BookingDate.checkOut)
//   ? new Date(bookingData.BookingDate.checkOut)
//   : (bookingData.checkOut ? new Date(bookingData.checkOut) : new Date());




//   const nights = Math.max(
//     1,
//     Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24))
//   );

//   const [selectedRoom, setSelectedRoom] = useState(null);
//   const [selectedCount, setSelectedCount] = useState(0);
//   const [formData, setFormData] = useState({
//     destination: property?.city || "",
//     checkIn: checkInDate.toISOString().split("T")[0],
//     checkOut: checkOutDate.toISOString().split("T")[0],
//     adults: 1,
//     children: 0,
//     rooms: 1,
//     childrenAgesNeeded: [],
//   });
//   const [showGuestPopup, setShowGuestPopup] = useState(false);

//   useEffect(() => {
//     const stored = JSON.parse(localStorage.getItem("BookingDate"));
//     if (stored) setFormData(stored);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleGuestChange = (type, action) => {
//     setFormData((prev) => {
//       let updated = { ...prev };
//       if (type === "adults") updated.adults = Math.max(1, action === "inc" ? prev.adults + 1 : prev.adults - 1);
//       if (type === "children") {
//         const newChildren = Math.max(0, action === "inc" ? prev.children + 1 : prev.children - 1);
//         updated.children = newChildren;
//         updated.childrenAgesNeeded = Array(newChildren).fill(0);
//       }
//       if (type === "rooms") updated.rooms = Math.max(1, action === "inc" ? prev.rooms + 1 : prev.rooms - 1);
//       return updated;
//     });
//   };

//   const handleChildAgeChange = (index, value) => {
//     setFormData((prev) => {
//       const newAges = [...prev.childrenAgesNeeded];
//       newAges[index] = value;
//       return { ...prev, childrenAgesNeeded: newAges };
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (formData.rooms === 0 || formData.adults === 0) return toast.success("Select at least 1 room and 1 adult");
//     if (!formData.checkIn || !formData.checkOut) return toast.success("Select check-in and check-out");
//     localStorage.setItem("BookingDate", JSON.stringify(formData));
//     toast.success("Booking data saved ✅");
//   };

//   // 🔹 Dynamic per-night price
//   const getRoomPriceForDate = (room, date) => {
//     const d = new Date(date);
//     // Discount first
//     // Calendar overrides
//     if (room.calendar?.length > 0) {
//       for (const entry of room.calendar) {
//         const start = new Date(entry.startDate);
//         const end = new Date(entry.endDate);
//         if (d >= start && d <= end) {
//           if (entry.status === "close") return null;
//           if (entry.status === "open" && entry.price != null) return entry.price;
//         }
//       }
//     }
//     if (room.discount?.isDiscountActive && room.discount?.priceAfterDiscount != null) return room.discount.priceAfterDiscount;

//     return room.nightlyPrice ?? 0;
//   };

//   const calculateTotalForRoom = (room, count) => {
//     const start = new Date(formData.checkIn);
//     const end = new Date(formData.checkOut);
//     let total = 0, totalTax = 0;
//     for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
//       const nightly = getRoomPriceForDate(room, d);
//       total += nightly;
//       totalTax += nightly * (room.tax / room.nightlyPrice || 0);
//     }
//     return { total: total * count, tax: totalTax * count };
//   };

//   const handleSelect = (value, room) => {
//     setSelectedCount(Number(value));
//     setSelectedRoom(room);
//   };

//   const setReverse = () => {
//     if (!selectedRoom) return toast.success("Select a room first");
//     const { total, tax } = calculateTotalForRoom(selectedRoom, selectedCount);
//     const isDiscountActive = selectedRoom.discount?.isDiscountActive || false;
//     const data = {
//       stayDurationInDays: nights,
//       bookingDate: { startDate: formData.checkIn, endDate: formData.checkOut },
//       totalPrice: total,
//       noOfRooms: selectedCount,
//       Room: selectedRoom,
//       property,
//       taxs: tax,
//       discountApplied: isDiscountActive,
//       discount: isDiscountActive ? { percentage: selectedRoom.discount.discountPercentage, discountedNightPrice: selectedRoom.discount.priceAfterDiscount } : null,
//     };
//     localStorage.setItem("Selected_Room", JSON.stringify(data));
//     navigate(`/book`);
//     console.log(data);
//   };

//   const renderBeds = (bedroomBeds = {}, livingRoomBeds = {}) => {
//     let beds = [];
//     if (bedroomBeds.single > 0) beds.push(`${bedroomBeds.single} single`);
//     if (bedroomBeds.double > 0) beds.push(`${bedroomBeds.double} double`);
//     if (bedroomBeds.king > 0) beds.push(`${bedroomBeds.king} king`);
//     if (bedroomBeds.queen > 0) beds.push(`${bedroomBeds.queen} queen`);
//     if (bedroomBeds.sofaCome > 0) beds.push(`${bedroomBeds.sofaCome} sofa bed`);
//     if (livingRoomBeds.sofa > 0) beds.push(`${livingRoomBeds.sofa} sofa`);
//     if (livingRoomBeds.sleeperSofas > 0) beds.push(`${livingRoomBeds.sleeperSofas} sleeper sofa`);
//     if (livingRoomBeds.futons > 0) beds.push(`${livingRoomBeds.futons} futon`);
//     if (livingRoomBeds.chair > 0) beds.push(`${livingRoomBeds.chair} chair`);
//     return beds.join(", ");
//   };

//   return (
//     <div className="availability">
//       {/* Search Form */}
//       <div className="search-section" style={{ justifyContent: "flex-start" }}>
//         <form className="search-bar" onSubmit={handleSubmit}>
//           <div className="search-field">
//             <label>Location</label>
//             <input type="text" name="destination" value={formData.destination} onChange={handleChange} className="date-input" />
//           </div>
//           <div className="search-field">
//             <label>Check-in</label>
//             <input type="date" name="checkIn" value={formData.checkIn} onChange={handleChange} className="date-input" />
//           </div>
//           <div className="search-field">
//             <label>Check-out</label>
//             <input type="date" name="checkOut" value={formData.checkOut} onChange={handleChange} className="date-input" />
//           </div>
//           <div className="search-field" style={{ position: "relative", minWidth: "220px" }}>
//             <label>Guests</label>
//             <div className="guest-box" onClick={() => setShowGuestPopup(!showGuestPopup)}>
//               {formData.adults} adults · {formData.children} children · {formData.rooms} room
//             </div>
//             {showGuestPopup && (
//               <div className="guest-popup">
//                 <div className="guest-row">
//                   <span>Adults</span>
//                   <div>
//                     <button type="button" onClick={() => handleGuestChange("adults", "dec")}>-</button>
//                     <span>{formData.adults}</span>
//                     <button type="button" onClick={() => handleGuestChange("adults", "inc")}>+</button>
//                   </div>
//                 </div>
//                 <div className="guest-row">
//                   <span>Children</span>
//                   <div>
//                     <button type="button" onClick={() => handleGuestChange("children", "dec")}>-</button>
//                     <span>{formData.children}</span>
//                     <button type="button" onClick={() => handleGuestChange("children", "inc")}>+</button>
//                   </div>
//                 </div>
//                 <div className="guest-row">
//                   <span>Rooms</span>
//                   <div>
//                     <button type="button" onClick={() => handleGuestChange("rooms", "dec")}>-</button>
//                     <span>{formData.rooms}</span>
//                     <button type="button" onClick={() => handleGuestChange("rooms", "inc")}>+</button>
//                   </div>
//                 </div>
//                 {formData.children > 0 && (
//                   <div className="child-ages">
//                     <label>Children Ages</label>
//                     {formData.childrenAgesNeeded.map((age, idx) => (
//                       <select key={idx} value={age} onChange={(e) => handleChildAgeChange(idx, e.target.value)}>
//                         {Array.from({ length: 18 }, (_, i) => <option key={i} value={i}>{i} years old</option>)}
//                       </select>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//           <button type="submit" className="search-btn">Search</button>
//         </form>
//       </div>

//       {/* Availability Table */}
//       <div className="availability-table1" style={{ display: "flex" }}>
//         <table className="availability-table">
//           <thead>
//             <tr>
//               <th>Room Type</th>
//               <th>Number of guests</th>
//               <th>Price for {nights} nights</th>
//               <th>Your choices</th>
//               <th>Select Rooms</th>
//             </tr>
//           </thead>
//           <tbody>
//             {property.rooms.map((room) => {
//               const { total } = calculateTotalForRoom(room, 1);
//               const hasDiscount = room.discount?.isDiscountActive;
//               return (
//                 <tr key={room.roomId}>
//                   <td>
//                     <div className="room-type">
//                       <a href="#" className="room-link">{room.roomDetails.roomName}</a>
//                       <div className="room-details">{renderBeds(room.bedroomBeds, room.livingRoomBeds)} <FaBed /></div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="guests-icons">{Array.from({ length: room.guests }).map((_, idx) => (<FaUsers key={idx} />))}</div>
//                   </td>
//                   <td>
//                     <span className="price">PKR {total.toLocaleString()}</span>
//                     {hasDiscount && (
//                       <div className="discount-note" style={{ color: "red" }}>
//                         <s>PKR {(room.nightlyPrice * nights).toLocaleString()}</s> ({room.discount.discountPercentage}% off)
//                       </div>
//                     )}
//                     <div className="price-note">+ taxes and charges</div>
//                   </td>
//                   <td>
//                     <ul className="choices-list">
//                       {room.breakfast?.types && room.breakfast.types[0] && (
//                         <li style={{ color: "green", marginBottom: "12px" }}>
//                           <FaCheckCircle style={{ marginRight: "6px" }} /> Continental breakfast included
//                         </li>
//                       )}
//                       <li style={{ marginBottom: "12px" }}>
//                         <FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> <b>No prepayment needed</b> – pay at the property
//                       </li>
//                       <li>
//                         <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} /> We have {room.roomDetails.noOfRooms} left
//                       </li>
//                     </ul>
//                   </td>
//                   <td style={{ width: "90px" }}>
//                     <select className="room-select" style={{ width: "90px" }} onChange={(e) => handleSelect(e.target.value, room)}>
//                       {Array.from({ length: room.roomDetails.noOfRooms + 1 }).map((_, i) => {
//                         const { total: optionTotal } = calculateTotalForRoom(room, i);
//                         return <option key={i} value={i}>{i === 0 ? "0" : `${i} × PKR ${optionTotal.toLocaleString()}`}</option>;
//                       })}
//                     </select>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>

//         {/* Summary Box */}
//         {selectedRoom && selectedCount > 0 && (
//           <div className="summary-box">
//             {(() => {
//               const { total, tax } = calculateTotalForRoom(selectedRoom, selectedCount);
//               const hasDiscount = selectedRoom.discount?.isDiscountActive;
//               return (
//                 <>
//                   <h4>
//                     {selectedCount} room{selectedCount > 1 ? "s" : ""} for <span className="price" style={{ color: "green" }}>PKR {total.toLocaleString()}</span>
//                     {hasDiscount && (
//                       <span style={{ textDecoration: "line-through", color: "red", marginLeft: "8px", fontSize: "14px" }}>
//                         PKR {((selectedRoom.nightlyPrice * selectedCount) * nights).toLocaleString()}
//                       </span>
//                     )}
//                     {hasDiscount && <span style={{ color: "green", marginLeft: "8px" }}>({selectedRoom.discount.discountPercentage}% off)</span>}
//                   </h4>
//                   <p>+ PKR {tax.toLocaleString()} taxes and fees</p>
//                   <button className="reserve-btn" onClick={setReverse}>I'll reserve</button>
//                   <br />
//                   <p className="note">Let's go to the next step</p>
//                   <p className="note">You won't be charged yet</p>
//                   <h5>Your package:</h5>
//                   <ul className="choices-list">
//                     {selectedRoom.breakfast?.types && selectedRoom.breakfast.types[0] && (
//                       <li><FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> Continental breakfast included</li>
//                     )}
//                     <br />
//                     <li><FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> No prepayment needed – pay at the property</li>
//                     <br />
//                     <li><FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} /> We have {selectedRoom.roomDetails.noOfRooms} left</li>
//                   </ul>
//                 </>
//               );
//             })()}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Availability;








import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaExclamationTriangle, FaBed, FaUsers } from "react-icons/fa";
import "./RoomAvaiblity.css";
import { toast } from "react-toastify";

const Availability = ({ property }) => {
  const navigate = useNavigate();

  const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};

  const checkInDate = (bookingData && bookingData.BookingDate && bookingData.BookingDate.checkIn)
    ? new Date(bookingData.BookingDate.checkIn)
    : (bookingData.checkIn ? new Date(bookingData.checkIn) : new Date());

  const checkOutDate = (bookingData && bookingData.BookingDate && bookingData.BookingDate.checkOut)
    ? new Date(bookingData.BookingDate.checkOut)
    : (bookingData.checkOut ? new Date(bookingData.checkOut) : new Date());

  const nights = Math.max(
    1,
    Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24))
  );

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedCount, setSelectedCount] = useState(0);
  const [formData, setFormData] = useState({
    destination: property?.city || "",
    checkIn: checkInDate.toISOString().split("T")[0],
    checkOut: checkOutDate.toISOString().split("T")[0],
    adults: 1,
    children: 0,
    rooms: 1,
    childrenAgesNeeded: [],
  });
  const [showGuestPopup, setShowGuestPopup] = useState(false);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("BookingDate"));
    if (stored) setFormData(stored);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGuestChange = (type, action) => {
    setFormData((prev) => {
      let updated = { ...prev };
      if (type === "adults") updated.adults = Math.max(1, action === "inc" ? prev.adults + 1 : prev.adults - 1);
      if (type === "children") {
        const newChildren = Math.max(0, action === "inc" ? prev.children + 1 : prev.children - 1);
        updated.children = newChildren;
        updated.childrenAgesNeeded = Array(newChildren).fill(0);
      }
      if (type === "rooms") updated.rooms = Math.max(1, action === "inc" ? prev.rooms + 1 : prev.rooms - 1);
      return updated;
    });
  };

  const handleChildAgeChange = (index, value) => {
    setFormData((prev) => {
      const newAges = [...prev.childrenAgesNeeded];
      newAges[index] = value;
      return { ...prev, childrenAgesNeeded: newAges };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.rooms === 0 || formData.adults === 0) return toast.success("Select at least 1 room and 1 adult");
    if (!formData.checkIn || !formData.checkOut) return toast.success("Select check-in and check-out");
    localStorage.setItem("BookingDate", JSON.stringify(formData));
    toast.success("Booking data saved ✅");
  };

  // 🔹 Helper: calculate dynamic remaining based on dateWiseRemaining
  const getAvailableFromDateWise = (room) => {
    const start = new Date(formData.checkIn);
    const end = new Date(formData.checkOut);
    let minRemaining = room.roomDetails?.noOfRooms ?? 0;
    const arr = room.roomDetails?.dateWiseRemaining || [];
    if (!arr.length) return minRemaining;

    const values = [];
    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
      const dateStr = d.toISOString().split("T")[0];
      const found = arr.find((x) => {
        if (!x.date) return false;
        return x.date.startsWith(dateStr) || x.date.split("T")[0] === dateStr;
      });
      if (found && typeof found.remaining === "number") {
        values.push(found.remaining);
      } else {
        values.push(room.roomDetails?.noOfRooms ?? 0);
      }
    }
    if (values.length === 0) return minRemaining;
    const minVal = Math.min(...values);
    return isFinite(minVal) ? minVal : minRemaining;
  };

  // 🔹 Dynamic per-night price
  const getRoomPriceForDate = (room, date) => {
    const d = new Date(date);
    if (room.calendar?.length > 0) {
      for (const entry of room.calendar) {
        const start = new Date(entry.startDate);
        const end = new Date(entry.endDate);
        if (d >= start && d <= end) {
          if (entry.status === "close") return null;
          if (entry.status === "open" && entry.price != null) return entry.price;
        }
      }
    }
    if (room.discount?.isDiscountActive && room.discount?.priceAfterDiscount != null)
      return room.discount.priceAfterDiscount;
    return room.nightlyPrice ?? 0;
  };

  const calculateTotalForRoom = (room, count) => {
    const start = new Date(formData.checkIn);
    const end = new Date(formData.checkOut);
    let total = 0, totalTax = 0;
    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
      const nightly = getRoomPriceForDate(room, d);
      total += nightly;
      totalTax += nightly * (room.tax / room.nightlyPrice || 0);
    }
    return { total: total * count, tax: totalTax * count };
  };

  const handleSelect = (value, room) => {
    setSelectedCount(Number(value));
    setSelectedRoom(room);
  };

  const setReverse = () => {
    if (!selectedRoom) return toast.success("Select a room first");
    const { total, tax } = calculateTotalForRoom(selectedRoom, selectedCount);
    const isDiscountActive = selectedRoom.discount?.isDiscountActive || false;
    const data = {
      stayDurationInDays: nights,
      bookingDate: { startDate: formData.checkIn, endDate: formData.checkOut },
      totalPrice: total,
      noOfRooms: selectedCount,
      Room: selectedRoom,
      property,
      taxs: tax,
      discountApplied: isDiscountActive,
      discount: isDiscountActive
        ? {
            percentage: selectedRoom.discount.discountPercentage,
            discountedNightPrice: selectedRoom.discount.priceAfterDiscount,
          }
        : null,
    };
    localStorage.setItem("Selected_Room", JSON.stringify(data));
    navigate(`/book`);
    console.log(data);
  };

  const renderBeds = (bedroomBeds = {}, livingRoomBeds = {}) => {
    let beds = [];
    if (bedroomBeds.single > 0) beds.push(`${bedroomBeds.single} single`);
    if (bedroomBeds.double > 0) beds.push(`${bedroomBeds.double} double`);
    if (bedroomBeds.king > 0) beds.push(`${bedroomBeds.king} king`);
    if (bedroomBeds.queen > 0) beds.push(`${bedroomBeds.queen} queen`);
    if (bedroomBeds.sofaCome > 0) beds.push(`${bedroomBeds.sofaCome} sofa bed`);
    if (livingRoomBeds.sofa > 0) beds.push(`${livingRoomBeds.sofa} sofa`);
    if (livingRoomBeds.sleeperSofas > 0) beds.push(`${livingRoomBeds.sleeperSofas} sleeper sofa`);
    if (livingRoomBeds.futons > 0) beds.push(`${livingRoomBeds.futons} futon`);
    if (livingRoomBeds.chair > 0) beds.push(`${livingRoomBeds.chair} chair`);
    return beds.join(", ");
  };

  return (
    <div className="availability">
      {/* Search Form */}
      <div className="search-section" style={{ justifyContent: "flex-start" }}>
        <form className="search-bar" onSubmit={handleSubmit}>
          <div className="search-field">
            <label>Location</label>
            <input type="text" name="destination" value={formData.destination} onChange={handleChange} className="date-input" />
          </div>
          <div className="search-field">
            <label>Check-in</label>
            <input type="date" name="checkIn" value={formData.checkIn} onChange={handleChange} className="date-input" />
          </div>
          <div className="search-field">
            <label>Check-out</label>
            <input type="date" name="checkOut" value={formData.checkOut} onChange={handleChange} className="date-input" />
          </div>
          <div className="search-field" style={{ position: "relative", minWidth: "220px" }}>
            <label>Guests</label>
            <div className="guest-box" onClick={() => setShowGuestPopup(!showGuestPopup)}>
              {formData.adults} adults · {formData.children} children · {formData.rooms} room
            </div>
            {showGuestPopup && (
              <div className="guest-popup">
                <div className="guest-row">
                  <span>Adults</span>
                  <div>
                    <button type="button" onClick={() => handleGuestChange("adults", "dec")}>-</button>
                    <span>{formData.adults}</span>
                    <button type="button" onClick={() => handleGuestChange("adults", "inc")}>+</button>
                  </div>
                </div>
                <div className="guest-row">
                  <span>Children</span>
                  <div>
                    <button type="button" onClick={() => handleGuestChange("children", "dec")}>-</button>
                    <span>{formData.children}</span>
                    <button type="button" onClick={() => handleGuestChange("children", "inc")}>+</button>
                  </div>
                </div>
                <div className="guest-row">
                  <span>Rooms</span>
                  <div>
                    <button type="button" onClick={() => handleGuestChange("rooms", "dec")}>-</button>
                    <span>{formData.rooms}</span>
                    <button type="button" onClick={() => handleGuestChange("rooms", "inc")}>+</button>
                  </div>
                </div>
                {formData.children > 0 && (
                  <div className="child-ages">
                    <label>Children Ages</label>
                    {formData.childrenAgesNeeded.map((age, idx) => (
                      <select key={idx} value={age} onChange={(e) => handleChildAgeChange(idx, e.target.value)}>
                        {Array.from({ length: 18 }, (_, i) => <option key={i} value={i}>{i} years old</option>)}
                      </select>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
          <button type="submit" className="search-btn">Search</button>
        </form>
      </div>

      {/* Availability Table */}
      <div className="availability-table1" style={{ display: "flex" }}>
        <table className="availability-table">
          <thead>
            <tr>
              <th>Room Type</th>
              <th>Number of guests</th>
              <th>Price for {nights} nights</th>
              <th>Your choices</th>
              <th>Select Rooms</th>
            </tr>
          </thead>
          <tbody>
            {property.rooms.map((room) => {
              const { total } = calculateTotalForRoom(room, 1);
              const hasDiscount = room.discount?.isDiscountActive;
              const availableRooms = getAvailableFromDateWise(room);

              return (
                <tr key={room.roomId}>
                  <td>
                    <div className="room-type">
                      <a href="#" className="room-link">{room.roomDetails.roomName}</a>
                      <div className="room-details">{renderBeds(room.bedroomBeds, room.livingRoomBeds)} <FaBed /></div>
                    </div>
                  </td>
                  <td>
                    <div className="guests-icons">{Array.from({ length: room.guests }).map((_, idx) => (<FaUsers key={idx} />))}</div>
                  </td>
                  <td>
                    <span className="price">PKR {total.toLocaleString()}</span>
                    {hasDiscount && (
                      <div className="discount-note" style={{ color: "red" }}>
                        <s>PKR {(room.nightlyPrice * nights).toLocaleString()}</s> ({room.discount.discountPercentage}% off)
                      </div>
                    )}
                    <div className="price-note">+ taxes and charges</div>
                  </td>
                  <td>
                    <ul className="choices-list">
                      {room.breakfast?.types && room.breakfast.types[0] && (
                        <li style={{ color: "green", marginBottom: "12px" }}>
                          <FaCheckCircle style={{ marginRight: "6px" }} /> Continental breakfast included
                        </li>
                      )}
                      <li style={{ marginBottom: "12px" }}>
                        <FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> <b>No prepayment needed</b> – pay at the property
                      </li>
                      <li>
                        <FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} /> We have {availableRooms} Rooms left
                      </li>
                    </ul>
                  </td>
                  <td style={{ width: "90px" }}>
                    <select className="room-select" style={{ width: "90px" }} onChange={(e) => handleSelect(e.target.value, room)}>
                      {Array.from({ length: availableRooms + 1 }).map((_, i) => {
                        const { total: optionTotal } = calculateTotalForRoom(room, i);
                        return <option key={i} value={i}>{i === 0 ? "0" : `${i} × PKR ${optionTotal.toLocaleString()}`}</option>;
                      })}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Summary Box */}
        {selectedRoom && selectedCount > 0 && (
          <div className="summary-box">
            {(() => {
              const { total, tax } = calculateTotalForRoom(selectedRoom, selectedCount);
              const hasDiscount = selectedRoom.discount?.isDiscountActive;
              return (
                <>
                  <h4>
                    {selectedCount} room{selectedCount > 1 ? "s" : ""} for <span className="price" style={{ color: "green" }}>PKR {total.toLocaleString()}</span>
                    {hasDiscount && (
                      <span style={{ textDecoration: "line-through", color: "red", marginLeft: "8px", fontSize: "14px" }}>
                        PKR {((selectedRoom.nightlyPrice * selectedCount) * nights).toLocaleString()}
                      </span>
                    )}
                    {hasDiscount && <span style={{ color: "green", marginLeft: "8px" }}>({selectedRoom.discount.discountPercentage}% off)</span>}
                  </h4>
                  <p>+ PKR {tax.toLocaleString()} taxes and fees</p>
                  <button className="reserve-btn" onClick={setReverse}>I'll reserve</button>
                  <br />
                  <p className="note">Let's go to the next step</p>
                  <p className="note">You won't be charged yet</p>
                  <h5>Your package:</h5>
                  <ul className="choices-list">
                    {selectedRoom.breakfast?.types && selectedRoom.breakfast.types[0] && (
                      <li><FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> Continental breakfast included</li>
                    )}
                    <br />
                    <li><FaCheckCircle style={{ marginRight: "6px", color: "green" }} /> No prepayment needed – pay at the property</li>
                    {/* <br /> */}
                    {/* <li><FaExclamationTriangle style={{ marginRight: "6px", color: "red" }} /> We have {selectedRoom.roomDetails.noOfRooms} left</li> */}
                  </ul>
                </>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default Availability;
